import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'SimpleSearchPipe'
})
export class SimpleSearchPipe implements PipeTransform {
  transform(items: any[], str): any {
    if (str === undefined || str === '') {
      return items;
    }
    let filtered = [];

    str = str.trim();
    let words = str.replace(new RegExp(' ', 'g'), '|');

    let rgx = new RegExp(words, 'gi');

      items.forEach(item => {
        item.points = (JSON.stringify(item).match(rgx) || []).length;
        if (item.points > 0) {
          filtered.push(item);
        }
      });

      filtered.sort((a: any, b: any) => {
        if (a.points < b.points) {
          return -1;
        } else if (a.points > b.points) {
          return 1;
        } else {
          return 0;
        }
      });

    return filtered;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/pipes/SimpleSearchPipe.ts